export const sizes = {
  mobile: {
    min: 344,
    max: 767,
  },
  tablet: {
    min: 768,
    max: 940,
  },
  desktop: {
    min: 1024,
    max: 1440,
  },
};

export const mediaQueryDevices = {
  minMobile: `max-width: ${sizes.mobile.min}px`,
  mobile: `max-width: ${sizes.mobile.max}px`,
  tablet: `max-width: ${sizes.tablet.max}px`,
  minDesktop: `max-width: ${sizes.desktop.min}px`,
  maxDesktop: `min-width: ${sizes.desktop.max}px`,
};
